"use client";

import { track } from "@/lib/analytics";
import { whatsappUrl } from "@/lib/whatsapp";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";

export default function WhatsAppFloatingButton() {
  const open = () => {
    track("contact_click", { label: "whatsapp_open" });
    window.open(whatsappUrl(), "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={open}
      type="button"
      aria-label="Fale conosco pelo WhatsApp"
      className="group fixed bottom-5 right-5 z-[60] inline-flex h-12 items-center gap-2.5 rounded-full border border-line/20 bg-surface/80 px-4 text-sm font-semibold text-fg shadow-[0_10px_40px_-8px_rgb(0_123_224_/_0.55)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-0.5 hover:border-electric/60 hover:shadow-[0_14px_48px_-6px_rgb(0_123_224_/_0.8)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric sm:right-6 sm:bottom-6 sm:px-5"
    >
      <span className="relative flex h-2 w-2" aria-hidden="true">
        <span className="absolute inline-flex h-full w-full animate-pulse-ring rounded-full bg-ok" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-ok" />
      </span>
      <WhatsAppIcon className="h-[18px] w-[18px] text-electric" aria-hidden="true" />
      <span className="hidden sm:inline">Fale conosco</span>
    </button>
  );
}
